import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Header from '../../components/atoms/Header'
import LoginBottomSheet from '../../components/molecules/LoginBottomSheet'
import MobileLayout from '../../components/MobileLayout'

import FoodScanGif from '../../assets/animations/food_scan.gif'
import CameraComponent from '../../components/organisms/CameraComponent'
import ArrowIcon from '../../components/atoms/Arrow'
import Button from '../../components/atoms/GoodFlipButton'
import { setCapturedImage } from '../../redux/slices/foodScanSlice'
import { useNavigate } from 'react-router-dom'
import { authenticateUserRequest } from '../../redux/slices'
import { sendMessageToParent } from '../../utils/helpers/common'
import { trackEventCKD } from '../../analytics'
import { EVENTS } from '../../analytics/events'
import TrackingPixel from '../../components/atoms/TrackingPixel'
import useLeadId from '../../hooks/useLead'
import sendEventData from '../../utils/helpers/sendMail'

const FoodScan = () => {
  const loginSheetRef = useRef(null)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { capturedImage, pndsScore } = useSelector((state) => state.foodScan)
  const { userDetails } = useSelector((state) => state.auth)
  const { questions } = useSelector((state) => state.questionnaire)

  const leadId = useLeadId()

  const [image, setImage] = useState(capturedImage)
  const [showCamera, setShowCamera] = useState(false)

  const queryParams = new URLSearchParams(location.search)
  const from = queryParams.get('from') ?? 'home'
  const phoneNumber = queryParams.get('phoneNumber') ?? null

  useEffect(() => {
    if (!!phoneNumber) {
      dispatch(
        authenticateUserRequest({
          contact_no: Number(phoneNumber),
          patient_meta_info: {
            support_program_type: 'Life Ka Filter',
          },
        }),
      )
    } else {
      if (!userDetails.data) {
        document.activeElement?.blur()
        loginSheetRef.current?.show()
      }
    }
  }, [])

  useEffect(() => {
    console.log('trackEventCKD --> CKD_LKF_Food_Scan_Landing')
    trackEventCKD(EVENTS.CKD_LKF_Food_Scan_Landing)
  }, [])

  // useEffect(() => {
  //   if (leadId && userDetails?.data?.contact_no) {
  //     sendEventData({
  //       lead_id: leadId,
  //       phone_no: userDetails?.data?.contact_no,
  //       page: 'food-scan',
  //     })
  //   }
  // }, [leadId, userDetails])

  const handleProceed = () => {
    dispatch(setCapturedImage(image))

    const pndsQuestions =
      questions?.filter((q) => q.type.includes('PNDS')) || []
    const allQuestionsAnswered = pndsQuestions.every((q) =>
      Array.isArray(q?.answer) ? q.answer.length > 0 : Boolean(q?.answer),
    )

    if (allQuestionsAnswered) {
      navigate('/result')
    } else {
      navigate(`/scan-food/proceed?from=${from}`)
    }
  }

  const navigateBack = () => {
    sendMessageToParent('NAVIGATE_BACK')
    if (image) {
      // dispatch(setCapturedImage(null))
      setImage(null)
    } else {
      navigate('/', { replace: true })
    }
  }

  return (
    <MobileLayout className={'!h-full'}>
      {/* {leadId && <TrackingPixel leadId={leadId} />} */}
      <div>
        <Header showProgressBar={false} onPressLeftIcon={navigateBack} />
        <div className="lg:max-w-2xl lg:mx-auto">
          <div className="flex items-center gap-3 p-4">
            <img
              src={FoodScanGif}
              className="rounded-full h-[100px] w-[100px]"
            />
            <div>
              <p className="font-manrope text-sm text-text-tertiary">
                Hold your plate 15 - 20 cm above your food and make sure all
                items are visible in the frame.
              </p>
              <p className="font-manrope text-sm text-text-tertiary">
                Note: Packaged food can not be detected.
              </p>
            </div>
          </div>

          {/* Camera Screen */}
          {image ? (
            <div className="relative h-[calc(100dvh-180px)]">
              <div className=" flex flex-col justify-center relative h-[calc(100dvh-281px)]">
                <div className="p-4  w-full flex items-center justify-center">
                  <img src={image} className="rounded-xl  w-full " />
                </div>
              </div>
              <div className="absolute bottom-0 flex w-full p-4 gap-3 pb-6">
                <Button
                  title={'Retake'}
                  onClick={() => {
                    dispatch(setCapturedImage(null))
                    setImage(null)
                  }}
                  rightIcon={null}
                  leftIcon={null}
                  className="!w-1/2 !m-0 !mt-0"
                ></Button>
                <Button
                  title={'Proceed'}
                  onClick={handleProceed}
                  className="!w-1/2 !m-0 !mt-0"
                  type="goodflip_primary"
                  rightIcon={<ArrowIcon direction="right" />}
                  leftIcon={null}
                ></Button>
              </div>
            </div>
          ) : (
            <div>
              <CameraComponent setImage={setImage} showCamera={showCamera} />
            </div>
          )}
        </div>
      </div>
      <LoginBottomSheet
        ref={loginSheetRef}
        buttonTitle={'Start Food Scan'}
        sheetHeader={'Enter mobile number to analyse your food'}
        onLoginSuccess={(userDetails, hasSentOTP) => {
          setShowCamera(true)
          if (hasSentOTP) {
            sendEventData({
              lead_id: leadId,
              phone_no: userDetails?.data?.contact_no,
              page: 'food-scan',
            })
          }
        }}
        from={'foodscan'}
      />
    </MobileLayout>
  )
}

export default FoodScan
